import { lazy, Suspense } from 'react';

const PdpSharedFramingStatusLazyComponent = lazy(() =>
    import(/* webpackChunkName: "PdpSharedFramingStatus" */ './PdpSharedFramingStatus')
);

export const PdpSharedFramingStatusLazy = props => (
    <Suspense fallback="">
        <PdpSharedFramingStatusLazyComponent {...props} />
    </Suspense>
);
